const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'templates',
		'componentTrees',
		'componentTrees'
	],

	config: {
		checkParentComponentID: false,
		showComponentsOnly: true,
		treeTypeComponents: {
			default: [
				'/',
				'templates',
				'componentTrees',
				'componentTreeInterface'
			]
		}
	},

	methods: {

		selectAll: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			this.checkAllNodes()
		},

		deselectAll: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			this.uncheckAllNodes()
		},

		onAttachDone: undefined
	},

	hooks: {
		import: function($element, options){
			options = options || {}
			if(utils.collectionSize(this.model.localAtoms) > 0){
				options.localAtoms = utils.simpleCopy(this.model.localAtoms || {})
			}
			this.triggerClosest('import', options)
			this.closest('base_modal_modal', async modal => {
				await modal.hide()
			})
		}
	},

	// NOTE: prevent componentTrees handlers from being called for this selectComponentTrees-Component
	handlers: undefined
};
